import { render } from "./AgentProjectBar.vue?vue&type=template&id=70f989d6&scoped=true"
import script from "./AgentProjectBar.vue?vue&type=script&lang=js"
export * from "./AgentProjectBar.vue?vue&type=script&lang=js"

import "./AgentProjectBar.vue?vue&type=style&index=0&id=70f989d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f989d6"]])

export default __exports__